$(function () {
	var $carousels = $('[data-carousel]');
	initCarousels($carousels);

	document.addEventListener('tab-switch', function() {
		initCarousels($carousels, true);
	});

	function initCarousels($carousels, reInit) {
		$carousels.each(function () {
			const $carousel = $(this);
			if (reInit && $carousel.hasClass('slick-initialized'))
				$carousel.slick('unslick');
			$carousel.slick({
				centerMode: true,
				centerPadding: '8%',
				slidesToShow: 3,
				infinite: true,
				responsive: [
					{
						breakpoint: 650,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});
		});
	}
});